import { AppBar, IconButton, Toolbar, Typography, makeStyles } from '@material-ui/core'
import React, { useState, useEffect, useCallback } from 'react'
import SideBar from "./SideBar/SideBar"
import MenuIcon from "@material-ui/icons/Menu"
import { useLocation } from "react-router-dom"
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import teal from "@material-ui/core/colors/cyan";



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1
    },
    paper: {
        background: teal[500]
      }
  }));

const NavBar = () => {
    const Menus = [
        { text: "Welcome", to: "/about", showInSideBar: false },
        { text: "Messages", to: "/messages", showInSideBar: true },
    { text: "Campaigns", to: "/campaigns", showInSideBar: true },
    { text: "Carrier Mapping", to: "/carrier-mapping", showInSideBar: true },
    { text: "Port Manager", to: "/port-manager", showInSideBar: true },
    { text: "Gateway Settings", to: "/gateway-settings", showInSideBar: true },
    { text: "Slims Domains", to: "/slims-domains", showInSideBar: true },
    { text: "Slims Domains Manager", to: "/slims-domains-manager", showInSideBar: true },
    { text: "Slims PRC", to: "/slims-prc", showInSideBar: true },
    { text: "CSB Manager", to: "/csb-manager", showInSideBar: true },
    { text: "DCL Manager", to: "/dcl-manager", showInSideBar: true },
]
    const [openDrawer, setOpenDrawer] = useState(false)
    const location = useLocation()


    const classes = useStyles()

    const checkPath = useCallback(() => {
        let path = location.pathname.split("/")

        if(path[1]){
            return location.pathname.replace("/", " - ")
        }else{
            return " - Home"
        }

    },
    [location.pathname]
    )
    // Check if the current pathname exists in Menus (i.e., it's NOT a 404 page)
    const isValidRoute = Menus.some(menu => menu.to === location.pathname);

    useEffect(() => {
        !isValidRoute && location.pathname !== "/" ? 
        document.title = "GMP - 404 - Page Not Found" : document.title = `GMP ${checkPath().replace(/\b\w/g, (char) => char.toUpperCase())}`
        
      }, [isValidRoute, location, checkPath]);

      const isAuthenticated = localStorage.getItem("user") !== null; // Check if user exists

    return (
        <React.Fragment>
            
            <AppBar  style={{backgroundColor: teal[500]}} className={classes.root} >
                <Toolbar >
                {isAuthenticated && isValidRoute && location.pathname !== "/" &&   <IconButton color="inherit" onClick={() => setOpenDrawer(true)}>
                        <MenuIcon />
                    </IconButton>}
                    <Typography variant="h6" className={classes.title} style={{ textTransform: "capitalize" }} >
                    GOIP - Manager Portal  {checkPath()}
                        </Typography>
                
                
                        <IconButton className={classes.menuButton} aria-label="show 11 new notifications" color="inherit">
                            <Badge badgeContent={11} color="secondary">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                    
                    {/* <Button color="inherit">Login</Button> */}
                    </Toolbar>
                    
            </AppBar>
            <Toolbar />
            <SideBar  Menus={Menus.filter(menu => menu.showInSideBar )}  open={openDrawer} close={() => setOpenDrawer(false)} color={classes.paper} />
        </React.Fragment>

    )
}

export default NavBar
